import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { IFilterFormField, TFilterFormValues } from 'common/types';
import { Link } from 'common/components/Link';

interface IProps {
    fields: IFilterFormField[];
}

/**
 * Clear action for a filter section header. Reads the current form values and
 * only renders when at least one of the section's fields differs from its
 * initial value; clicking it resets those fields to their initial value.
 */
export const FilterSectionClearButton = ({ fields }: IProps) => {
    const [translate] = useTranslation();
    const { values, setFieldValue } = useFormikContext<TFilterFormValues>();

    const hasValue = fields.some((field) => {
        const value = values[field.name];

        if (value == null) return false;

        return JSON.stringify(value) !== JSON.stringify(field.initialValue);
    });

    if (!hasValue) return null;

    const handleClear = (event: React.MouseEvent) => {
        // Don't toggle the accordion when clearing.
        event.stopPropagation();

        fields.forEach((field) =>
            setFieldValue(field.name, field.initialValue)
        );
    };

    return (
        <Link
            sx={{ cursor: 'pointer', position: 'relative', top: '1px', mr: 1 }}
            onClick={handleClear}
        >
            {translate('filterForm.clearSelection')}
        </Link>
    );
};
